import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { MEGStoreService } from "src/app/services/meg/meg-store.service";
import { GlobalService } from "../../../services/global/global.service";

@Component({
	selector: "app-account-faq",
	templateUrl: "./account-faq.component.html",
	styleUrls: ["./account-faq.component.css"]
})
export class AccountFaqComponent implements OnInit {
	constructor(
		public router: Router,
		public globalService: GlobalService,
		public megStoreService: MEGStoreService
	) {}

	ngOnInit() {}
	public back() {
		this.router.navigate([this.globalService.routerLastUrl], {
			skipLocationChange: true
		});
	}
}
